module.exports = __webpack_public_path__ + "static/sportovni-odpoledne-na-czu-02-1b9c575e69ee622dd854afc034beab62.jpg";